var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowLoggedinfields && _vm.isHeaderShow,
            expression: "isShowLoggedinfields && isHeaderShow"
          }
        ],
        staticClass: "header-section-web col-12 float-l"
      },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "logo-section float-l" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "float-l",
                    attrs: { to: { name: "ChatList" } }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/static/images/vvglogonew.png",
                        alt: "Velocity Vehicle Group"
                      }
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "header-right-section float-r" }, [
              _c("div", { staticClass: "form-group float-l" }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                  },
                  [_vm._v(" User ")]
                ),
                _vm._v(" "),
                _c("ul", { staticClass: "nav navbar-nav navbar-right" }, [
                  _c("li", { staticClass: "dropdown" }, [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-toggle",
                        attrs: {
                          href: "javascript:void(0)",
                          "data-toggle": "dropdown",
                          "aria-expanded": "false"
                        }
                      },
                      [
                        _c("p", { staticClass: "mb_0" }, [
                          _vm._v(_vm._s(_vm.loggedin_user_name))
                        ]),
                        _vm._v(" "),
                        _vm._m(0)
                      ]
                    ),
                    _vm._v(" "),
                    _c("ul", { staticClass: "dropdown-menu" }, [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "SiteList" } } },
                            [_vm._v("My Sites")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.cantAccessPage === true
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "UserList" } } },
                                [_vm._v("User List")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.cantAccessPage === true
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "CustomerList" } } },
                                [_vm._v("Customer List")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "ArchivedChat" } } },
                            [_vm._v("Archived Chat")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.currentEnvironment && _vm.cantAccessPage === true
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                { attrs: { to: { name: "MailList" } } },
                                [_vm._v("Mail List")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.cantAccessPage === true
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "ListSectionSchedulerTime" }
                                  }
                                },
                                [_vm._v("Schedule Section")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group float-l" }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                  },
                  [_vm._v(" Status ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown" }, [
                  _c("ul", { staticClass: "nav navbar-nav navbar-right" }, [
                    _c("li", { staticClass: "dropdown" }, [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-toggle",
                          attrs: {
                            href: "javascript:void(0)",
                            "data-toggle": "dropdown",
                            "aria-expanded": "false"
                          }
                        },
                        [
                          _c("p", { staticClass: "mb_0" }, [
                            _vm._v(" " + _vm._s(_vm.status) + " ")
                          ]),
                          _vm._v(" "),
                          _vm._m(1)
                        ]
                      ),
                      _vm._v(" "),
                      _c("ul", { staticClass: "dropdown-menu" }, [
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.changeStatus("online")
                                }
                              }
                            },
                            [_vm._v(" Online ")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.changeStatus("offline")
                                }
                              }
                            },
                            [_vm._v(" Offline ")]
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "logout-btn float-r" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary internal-large-btn",
                    attrs: { id: "logoutbtn", type: "submit" },
                    on: {
                      click: function($event) {
                        return _vm.logout()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                            Logout\n                        "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.isShowLoggedinfields &&
    (_vm.routePathModule != "chat" || _vm.mobileHeaderText != "Customer Detail")
      ? _c(
          "div",
          {
            staticClass:
              "header-section header-section-mobile col-12 float-l bgcolor-cfe3ee"
          },
          [
            _c(
              "div",
              { staticClass: "back-btn-chat float-l" },
              [
                _vm.mobileHeaderText == "User Detail"
                  ? _c("router-link", { attrs: { to: { name: "UserList" } } }, [
                      _c("i", { staticClass: "hi-icon icon-chatback" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.mobileHeaderText == "User List"
                  ? _c("router-link", { attrs: { to: { name: "ChatList" } } }, [
                      _c("i", { staticClass: "hi-icon icon-chatback" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.mobileHeaderText == "Customer List"
                  ? _c("router-link", { attrs: { to: { name: "ChatList" } } }, [
                      _c("i", { staticClass: "hi-icon icon-chatback" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.mobileHeaderText == "User Create"
                  ? _c("router-link", { attrs: { to: { name: "UserList" } } }, [
                      _c("i", { staticClass: "hi-icon icon-chatback" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.mobileHeaderText == "Archived Chat"
                  ? _c("router-link", { attrs: { to: { name: "ChatList" } } }, [
                      _c("i", { staticClass: "hi-icon icon-chatback" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.mobileHeaderText == "Site List"
                  ? _c("router-link", { attrs: { to: { name: "ChatList" } } }, [
                      _c("i", { staticClass: "hi-icon icon-chatback" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.mobileHeaderText == "Schedule Section"
                  ? _c("router-link", { attrs: { to: { name: "ChatList" } } }, [
                      _c("i", { staticClass: "hi-icon icon-chatback" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.mobileHeaderText ==
                "Add Schedule Section (All times are in Sydney)"
                  ? _c(
                      "router-link",
                      { attrs: { to: { name: "ListSectionSchedulerTime" } } },
                      [_c("i", { staticClass: "hi-icon icon-chatback" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentEnvironment && _vm.mobileHeaderText == "Mail List"
                  ? _c("router-link", { attrs: { to: { name: "MailList" } } }, [
                      _c("i", { staticClass: "hi-icon icon-chatback" })
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "customer-name float-l colpie-80" }, [
              _vm.mobileHeaderText != "User Create"
                ? _c(
                    "p",
                    {
                      staticClass:
                        "color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_10 pl_40 mb_0"
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.mobileHeaderText) + "\n            "
                      )
                    ]
                  )
                : _c(
                    "p",
                    {
                      staticClass:
                        "color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_10 pl_40 mb_0"
                    },
                    [_vm._v(" Add User\n            ")]
                  )
            ]),
            _vm._v(" "),
            _vm.mobileHeaderText == "Chat List"
              ? _c("div", { staticClass: "right-header-section float-r" }, [
                  _c("div", { staticClass: "search-bar-right" }, [
                    _c("div", { staticClass: "searchbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchText,
                            expression: "searchText"
                          }
                        ],
                        staticClass: "searchbox-input",
                        attrs: {
                          type: "search",
                          placeholder: "Search......",
                          name: "search",
                          required: ""
                        },
                        domProps: { value: _vm.searchText },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.searchText = $event.target.value
                            },
                            function($event) {
                              return _vm.searchAPI(_vm.mobileHeaderText)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      !_vm.searchOpen
                        ? _c(
                            "a",
                            {
                              staticClass: "searchbox-icon",
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.searchBoxClose()
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: "/static/images/search-close.png"
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.searchOpen
                        ? _c(
                            "span",
                            {
                              staticClass: "searchbox-icon",
                              on: {
                                click: function($event) {
                                  return _vm.searchBoxOpen()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "hi-icon icon-chatmagnifying-glass"
                              })
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "menu-right-header float-r" }, [
              _c("div", { staticClass: "nc-chat-right-dropdown" }, [
                _c("div", { staticClass: "dropdown" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("ul", { staticClass: "dropdown-menu" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "user-name color-f5911e heading-text-14 line-height-20 font-benton-bold float-l width-full"
                      },
                      [
                        _vm.status == "Online" || _vm.status == "online"
                          ? _c("span", {
                              staticClass:
                                "bgcolor-5cbb55 p_5 pull-left absolute l-15 t-5 radius-100"
                            })
                          : _c("span", {
                              staticClass:
                                "bgcolor-ff3636 p_5 pull-left absolute l-15 t-5 radius-100"
                            }),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.loggedin_user_name) +
                            "\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "SiteList" } } },
                          [
                            _vm._v("My Sites "),
                            _c("span", [
                              _c("i", {
                                staticClass: "fa fa-angle-right custom"
                              })
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.cantAccessPage === true
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "UserList" } } },
                              [
                                _vm._v(" User List "),
                                _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-angle-right custom"
                                  })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cantAccessPage === true
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "CustomerList" } } },
                              [
                                _vm._v(" Customer List "),
                                _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-angle-right custom"
                                  })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cantAccessPage === true
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "ArchivedChat" } } },
                              [
                                _vm._v(" Archived Chat "),
                                _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-angle-right custom"
                                  })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentEnvironment && _vm.cantAccessPage === true
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "MailList" } } },
                              [
                                _vm._v(" Mail List "),
                                _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-angle-right custom"
                                  })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cantAccessPage === true
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { name: "ListSectionSchedulerTime" }
                                }
                              },
                              [
                                _vm._v(" Schedule Section "),
                                _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-angle-right custom"
                                  })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.status == "Online" || _vm.status == "online") &&
                    _vm.routePathModuleDetail != "detail"
                      ? _c("li", { staticClass: "user-status-edit" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.changeStatus("offline")
                                }
                              }
                            },
                            [
                              _vm._v(
                                " Offline\n                                "
                              ),
                              _vm._m(3)
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.status == "offline" || _vm.status == "Offline") &&
                    _vm.routePathModuleDetail != "detail"
                      ? _c("li", { staticClass: "user-status-edit" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.changeStatus("online")
                                }
                              }
                            },
                            [
                              _vm._v(
                                " Online\n                                "
                              ),
                              _vm._m(4)
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.logout()
                            }
                          }
                        },
                        [_vm._v(" Sign Out "), _vm._m(5)]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-down" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-down" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "more-btn btn btn-primary dropdown-toggle",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _c("span", { staticClass: "more-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "more-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "more-dot" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a5fdd6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a5fdd6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = null
// module chunks = 